/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Swal_TitleInputs */



/**
* | output |
* | --- |
* | "Complete Checkout in Browser" |
*
* @param {Signup_Swal_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_swal_title = /** @type {((inputs?: Signup_Swal_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Swal_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Terminer le Paiement dans le Navigateur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kaufvorgang im Browser abschließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Completa il checkout nel browser")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Завершите оформление заказа в браузере.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Completar el pago en el navegador")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在浏览器中完成结账")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ブラウザでチェックアウトを完了する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ब्राउज़र में चेकआउट प्रक्रिया पूरी करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Finalize a compra no navegador")
	return /** @type {LocalizedString} */ ("Complete Checkout in Browser")
});